//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import card from '@/components/card/card.vue';
import preview from '@/components/preview.vue';
import avatar from '@/components/avatar.vue';
import share from '@/components/share.vue';
import { setting_obj } from '@/settings/setting';
import { isMobile } from '@/utils/constants';
import { handlePraise, handleCopy } from '@/utils/userTools';
import reportTip from '@/components/card/report-tip.vue';
import { diffTime, dfsTransformXssKeys, formatPath, toTagPage, replaceToOriginStr } from '~/utils/tools';
import { handleUserBehaviorByType } from '@/components/subscription/subscription.js';

const xss = require('xss');

let isClick = false;
let resourcePageInitTime = new Date().getTime();
export default {
  components: {
    card,
    preview,
    avatar,
    share,
    reportTip,
  },
  data() {
    return {
      resourceInfo: {},
      iframeObj: {
        fileUrl: '',
        coverUrl: '',
        width: '',
        height: '',
        border: '8px',
        showZoomButton: true,
        showProgressBar: false,
      },
      likeList: [],
      labels: ['Button', '设计系统', 'Ant', 'Antd', 'Components', 'Design System', '组件库', '组件'],
      isSelf: false,
      err: null,
      env: process.env.CURRENT_ENV,
      server_env: '',
      server_axios: null,
      PORT: '',
      resource_res: {},
      detailUrl: '',
      showLabelTips: false,
      authorOtherList: [],
      total: 0,
      res_desc: '',
    };
  },
  async asyncData({ app, params, query, redirect }) {
    if (query.no_ssr === '1') {
      return {
        err: 'no_ssr',
        server_env: process.env.CURRENT_ENV,
        server_axios: app.$axios,
        PORT: process.env.PORT,
        resource_res: null,
        detailUrl: null,
      };
    }
    const id = +params.id;
    const detailUrl = query.from === 'admin' ? '/admin/community/api/info' : '/community/api/detail';

    try {
      const res = await app.$axios.$get(detailUrl, {
        params: {
          res_id: id,
          from: query.from ?? '',
        },
      });
      const data = res.data;
      const resourceInfo = data;
      app.head.title = replaceToOriginStr(`${data.res_name}-MasterGo 社区`);
      return {
        resourceInfo,
        res_id: id,
        server_env: process.env.CURRENT_ENV,
        server_axios: app.$axios,
        PORT: process.env.PORT,
        resource_res: res,
        detailUrl,
      };
    } catch (e) {
      console.log('err', e);
      if (e?.response?.status === 404) return redirect('/404/resource');
      return {
        err: e,
        server_env: process.env.CURRENT_ENV,
        server_axios: app.$axios,
        PORT: process.env.PORT,
        resource_res: null,
        detailUrl: null,
      };
    }
  },
  computed: {
    updateTime() {
      const time = this.resourceInfo.submit_time;
      return time ? diffTime(new Date(time).getTime()) : '暂无时间';
    },

    isFromAdmin() {
      return this.$route.query?.from === 'admin';
    },
  },
  beforeCreate() {
    resourcePageInitTime = new Date().getTime();
  },
  async mounted() {
    if (!isMobile()) {
      this.showLabelTips = !window.localStorage.getItem('SHOWED_LABEL_TIPS');
    }
    if (this.showLabelTips) {
      setTimeout(() => {
        window.localStorage.setItem('SHOWED_LABEL_TIPS', 1);
      }, 1000);
    }
    await this.initSsr();
    this.formatData();
    const { from, r_index } = this.$route?.query || {};
    if (from === 'official_website') {
      const sensorParams = {
        action_position: from,
        resource_id: this.resourceInfo.res_id,
        resource_name: this.resourceInfo.res_name,
      };
      if (r_index) {
        sensorParams.action_detail = r_index;
      }
      // 根据来源增加访问社区文件埋点
      this.$sensors.track('get_resource', sensorParams);
    }

    this.$sensors.track('page_view', {
      action_position: 'resource_detail',
      resource_id: this.resourceInfo.res_id,
      resource_name: this.resourceInfo.res_name,
      action_parameter0: 'resource',
    });

    this.calcSize();
    const userInfo_id = this.$store?.state?.user?.userInfo?.id;
    let { author_id } = this.resourceInfo;
    author_id = author_id ? `${author_id}` : '';
    this.isSelf = userInfo_id === +author_id;
  },
  destroyed() {
    window.onresize = null;
  },
  methods: {
    closeGuide() {
      this.showLabelTips = false;
    },
    async initSsr() {
      const query = this.$route.query;
      const params = this.$route.params;
      let res_label = '';
      let res_cata = '';

      if (this.resourceInfo.res_id === undefined) {
        const detailUrl = query.from === 'admin' ? '/admin/community/api/info' : '/community/api/detail';

        try {
          const res = await this.$axios.$get(detailUrl, {
            params: {
              res_id: Number(params.id) || 0,
              from: query.from ?? '',
            },
          });
          const data = res.data;
          const resourceInfo = data;
          res_label = data?.res_label?.join(',') || '';
          res_cata = data?.res_cata?.join(',') || '';
          this.resourceInfo = resourceInfo;
          this.res_id = Number(params.id);
          this.resource_res = res;
        } catch (e) {
          console.log('err', e);
        }
      }
      res_label = this.resourceInfo?.res_label?.join(',') || '';
      res_cata = this.resourceInfo?.res_cata?.join(',') || '';
      const resLike = await this.$axios.$post('/community/api/guess-like', {
        res_label,
        res_id: Number(params.id),
        res_cata,
      });
      this.likeList = resLike.data;

      try {
        const resAuthorOther = await this.$axios.$post('/community/api/user-release-list', {
          user_id: this.resourceInfo?.author_id || '',
          res_id: Number(params.id),
        });
        this.total = resAuthorOther.meta?.page?.total || 0;
        const data = this.total > 6 ? resAuthorOther.data.slice(0, 6) : resAuthorOther.data;
        this.authorOtherList = data.slice(0, 6);
      } catch (e) {
        console.log('err', e);
      }
    },
    formatData() {
      if (!this.resourceInfo) return;
      dfsTransformXssKeys(this.resourceInfo);
      const pathObj = {
        0: setting_obj.filePreviewPath,
        1: setting_obj.protoPath,
      };
      const { file_key, cover_url, display_mode, res_desc } = this.resourceInfo;
      const coverPath = formatPath(cover_url, setting_obj.imageCdnPath);
      const fileUrl = formatPath(file_key, pathObj[display_mode]);
      if (res_desc) {
        this.res_desc = xss(res_desc);
      }
      this.iframeObj = {
        fileUrl: isMobile() ? '' : fileUrl,
        coverUrl: coverPath,
        width: '',
        height: '',
        border: '8px',
        showZoomButton: true,
        showProgressBar: !isMobile(),
      };
    },
    calcSize() {
      this.initSize();
      window.onresize = () => {
        this.initSize();
      };
    },
    initSize() {
      const el = this.$refs.preview;
      if (!el) return;
      const width = el.offsetWidth;
      const height = width * (9 / 16);
      el.style.height = `${height}px`;
      this.iframeObj.width = `${width}px`;
      this.iframeObj.height = `${height}px`;
    },
    goFile(id) {
      const targetId = id || this.resourceInfo.doc_id;
      if (!targetId) return;
      const url = `/file/${targetId}`;

      if (isMobile()) {
        // 如果是移动端
        location.href = url;
      } else {
        window.open(url, '_blank', 'noopener,noreferrer');
      }
    },
    edit() {
      this.goFile();
    },
    unpublish() {
      alert('取消');
    },
    like() {
      if (!this.res_id || isClick) return;
      isClick = true;
      handlePraise({ res_id: this.res_id, action_type: this.resourceInfo.favorite ? 2 : 1 })
        .then(() => {
          const { res_id, res_name, favorite } = this.resourceInfo;
          this.resourceInfo.favorite = !favorite;
          // this.$sensors.track('like_resource', {
          //   action_type: this.resourceInfo.favorite ? 'like' : 'unlike',
          //   resource_id: res_id,
          //   resource_name: res_name,
          // });
          this.setFavoriteSensors(this.resourceInfo.favorite, res_id, res_name);
          if (this.resourceInfo.favorite) {
            this.resourceInfo.like_cnt++;
          } else {
            this.resourceInfo.like_cnt--;
          }
          isClick = false;
        })
        .catch(() => {
          isClick = false;
        });
    },
    copy() {
      if (!this.res_id || isClick) return;
      isClick = true;
      handleCopy(Number(this.res_id), this.$store?.state?.user?.currentOrg)
        .then((res) => {
          handleUserBehaviorByType('resource');
          const id = res.data.id;
          this.resourceInfo.copy_cnt++;
          this.goFile(id);
          isClick = false;
        })
        .catch((error) => {
          if (error?.response?.data?.code === 'NoDocumentResourcePermission') {
            this.$message({
              message: error.response.data.data.toast ?? '',
              type: 'error',
            });
          }
          isClick = false;
        });
    },
    goUser() {
      const routeData = this.$router.resolve({ name: 'profile-id', params: { id: this.resourceInfo.author_id } });
      window.open(routeData.href, '_blank', 'noopener,noreferrer');
    },
    hideBorder() {
      this.iframeObj.border = 0;
    },
    handlePageTimeLog(mgCanvasReadyTime, iframeFinishedTime, layerSize) {
      if (!mgCanvasReadyTime || !iframeFinishedTime) return;
      const pageOpenToIframed = mgCanvasReadyTime - resourcePageInitTime;

      this.$sensors.track('community_iframe_load', {
        action_position: 'resource',
        resource_id: this.resourceInfo.res_id,
        resource_name: this.resourceInfo.res_name,
        action_parameter0: pageOpenToIframed,
        action_parameter1: iframeFinishedTime,
        action_parameter5: layerSize,
      });
    },
    goTagPage(label) {
      toTagPage(label);
      this.setTagSensors();
    },
    setTagSensors() {
      this.$sensors.track('event_click', {
        action_position: 'resource_detail',
        action_parameter1: 'tag',
      });
    },
    setFavoriteSensors(favorite, res_id, res_name) {
      const type = favorite ? 'add' : 'remove';
      this.$sensors.track('event_click', {
        action_position: 'resource_detail',
        action_parameter1: 'favorite',
        resource_id: res_id,
        resource_name: res_name,
        action_type: type,
      });
    },
    // async initData() {
    //   const params = {
    //     res_id: this.res_id,
    //   };
    //   const res = await this.$axios.$get('resource/detail', { params });
    //   this.resourceInfo = res;
    //   const labels = this.resourceInfo.res_label.join(',');
    //   const likeList = await this.$axios.$post('resource/guess-like', {
    //     labels,
    //   });
    // },
  },
};
